import { Component, OnInit, TemplateRef } from "@angular/core";
import { ListService } from "../../../../auth/service/list.service";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../../auth/service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

interface InvoiceService {
  id?: number;
  name: string;
  other: {
    code: string;
    storage_unit_measure: string;
    code_purchases: string;
    purchases_vat: string;
    sales_account_code: string;
    sales_vat: string;
    default: boolean;
  };
}

@Component({
  selector: "app-invoice-services",
  templateUrl: "./invoice-services.component.html",
})

export class InvoiceServicesComponent implements OnInit {

  public contentHeader: IContentHeader;
  private list_type = "invoice_service";
  public tableLimit: number = 10;
  public searchKeyword: string = "";

  public services: InvoiceService[] = [];
  public filteredServices: InvoiceService[] = [];

  public showModalError: boolean = false;
  public serviceForm: InvoiceService = { name: '', other: { code: '' } } as InvoiceService;

  constructor(
    private _routerService: Router,
    public _authenticationService: AuthenticationService,
    public listService: ListService,
    private _modalService: NgbModal,
    public _utilService: UtilsService,
  ) {

    this.contentHeader = {
      headerTitle: "MENU.SERVICE_INVOICE",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: "MENU.SERVICE_INVOICE",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability(`show_${this.list_type}_list`)) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }
    this.load();
  }

  load() {
    this.listService.getList(this.list_type).then((result: any) => {
      this.services = result;
      this.filterTypes();
    });
  }

  filterTypes() {
    const key: string = this.searchKeyword.trim().toLowerCase();
    let filterItem: InvoiceService[] = this.services;
    if (key.length > 0) {
      filterItem = filterItem.filter((item: InvoiceService) => item.name.toLowerCase().trim().includes(key));
    }
    this.filteredServices = filterItem;

  }

  modalOpen(modal: TemplateRef<any>, selectedService: InvoiceService) {
    this._modalService.open(modal, {
      size: "lg",
      centered: true,
    });
    this.serviceForm = {
      name: '',
      other: {
        code: '',
        storage_unit_measure: '0',
        code_purchases: '',
        purchases_vat: '22',
        sales_account_code: '',
        sales_vat: '22',
        default: false,
      },
    };
    if (selectedService) {
      this.serviceForm = { ...this.serviceForm, ...selectedService };
    }
    this.showModalError = false;
  }

  isError(): boolean {
    this.showModalError = this.serviceForm.name === null || this.serviceForm.name.length < 1 || this.serviceForm.other.code === null || this.serviceForm.other.code.length < 1;
    return this.showModalError;
  }

  async addService() {
    if (!this._authenticationService.hasCapability(`create_${this.list_type}`)) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.isError()) {
      return false;
    }

    delete this.serviceForm.id;

    this._utilService.showLoading();
    await this.listService
      .create(this.serviceForm, this.list_type)
      .then(() => {
        this._modalService.dismissAll();
        this.load();
        this._utilService.hideLoading();
        this._utilService.showToastrSuccess("SUCCESS_ADD_INVOICE_SERVICE");
        this.serviceForm = { name: '', other: { code: '' } } as InvoiceService;
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showToastrError("ERROR_ADD_INVOICE_SERVICE");
      });
  }

  async editService() {
    if (!this._authenticationService.hasCapability(`edit_${this.list_type}`)) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.isError()) {
      return false;
    }

    const idType: number = this.serviceForm.id;
    delete this.serviceForm.id;

    this._utilService.showLoading();
    await this.listService
      .update(idType, this.serviceForm, this.list_type)
      .then(() => {
        this._modalService.dismissAll();
        this.load();
        this._utilService.hideLoading();
        this._utilService.showToastrSuccess("SUCCESS_EDIT_INVOICE_SERVICE");
        this.serviceForm = {
          name: null,
          other: {
            code: null,
          },
        } as InvoiceService;
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showToastrError("ERROR_EDIT_INVOICE_SERVICE");
      });
  }

  async deleteService(selected: any) {
    if (!this._authenticationService.hasCapability(`delete_${this.list_type}`)) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }

    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += selected.name;

    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this.listService.delete(selected.id, this.list_type).then(() =>
            this._utilService.showPopupItemDeleted().then(async () => {
              this.load();
              await this._utilService.showToastrSuccess("SUCCESS_DELETE_INVOICE_SERVICE");
            }),
          );
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => this._utilService.showToastrError("ERROR_DELETE_INVOICE_SERVICE"));
  }
}
